
import Vue from 'vue';
import * as ENDPOINTS from './endpoints';
import { resolveRequestError } from '@/utils/auth';

export default class PromoService {
    //====================== retrive all tutorials =============================//

    static async getAllTutorials() {

        try {
            const { data } = await Vue.http.get(ENDPOINTS.TUTORIALS);
            if (data.status == 200) {
                return data.data;
            }
            else {
                return []
            }

        } catch (error) {
            resolveRequestError(error);
        }


    }
    // ================= function create crypto coin ===================//
    static async addTutorialsModule(tutorials) {

        try {
            const { data } = await Vue.http.post(ENDPOINTS.TUTORIALS, tutorials);
            return data
        } catch (error) {
            resolveRequestError(error);
        }
    }
    // ================= function create crypto coin ===================//
    static async editTutorialsModule(tutorials) {
        try {
            const { data } = await Vue.http.put(`${ENDPOINTS.TUTORIALS}?id=${tutorials.id}`, tutorials);
            return data
        } catch (error) {
            resolveRequestError(error);
        }
    }
    // ================= function delete tutorials ===================//
    static async deleteTutorial(tutorials) {
        try {
            const { data } = await Vue.http.delete(`${ENDPOINTS.TUTORIALS}?id=${tutorials.id}`);
            return data
        } catch (error) {
            resolveRequestError(error);
        }
    }
    //====================== retrive all tutorials =============================//

    static async getAllHottest() {

        try {
            const { data } = await Vue.http.get(ENDPOINTS.HOTTEST);
            if (data.status == 200) {
                return data.data;
            }
            else {
                return []
            }

        } catch (error) {
            resolveRequestError(error);
        }


    }
    //====================== retrive all stores =============================//
    static async loadStores() {

        try {
            const { data } = await Vue.http.get(ENDPOINTS.GIFTCARD_STORES);
            if (data) {
                return data;
            }
            else {
                return []
            }

        } catch (error) {
            resolveRequestError(error);
        }


    }
    // ================= function add  hottest giftcard ===================//
    static async addHottest(giftcard) {
        try {
            const { data } = await Vue.http.put(`${ENDPOINTS.HOTTEST}?giftcard=${giftcard.giftcard_id}`);
            return data
        } catch (error) {
            resolveRequestError(error);
        }
    }
    // ================= function delete hottest giftcard ===================//
    static async deleteHottest(giftcard) {

        try {
            const { data } = await Vue.http.delete(`${ENDPOINTS.HOTTEST}?giftcard=${giftcard.giftcard_id}`);
            return data
        } catch (error) {
            resolveRequestError(error);
        }
    }
    //====================== retrive all traders crypto =============================//

    static async getCryptoTraders({startDate, endDate}) {

        try {
            const { data } = await Vue.http.get(ENDPOINTS.CRYPTO_TRADERS, {
                params: {
                    startDate,
                    endDate
                }
            });
            if (data.status == 200) {
                return data.data;
            }
            else {
                return []
            }

        } catch (error) {
            resolveRequestError(error);
        }


    }
    //====================== retrive all traders giftcard =============================//
    static async getGiftcardTraders({startDate, endDate}) {

        try {
            const { data } = await Vue.http.get(ENDPOINTS.GIFTCARD_TRADERS, {
                params: {
                    startDate,
                    endDate
                }
            });
            if (data.status == 200) {
                return data.data;
            }
            else {
                return []
            }

        } catch (error) {
            resolveRequestError(error);
        }


    }
    //====================== retrive top 10 traders crypto =============================//
    static async getTopCryptoTraders({startDate, endDate}) {

        try {
            const { data } = await Vue.http.get(ENDPOINTS.TOP_CRYPTO, {
                params: {
                    startDate,
                    endDate
                }
            });
            if (data.status == 200) {
                return data.data;
            }
            else {
                return []
            }

        } catch (error) {
            resolveRequestError(error);
        }


    }
    //====================== retrive top 10 giftcard =============================//

    static async getTopGiftcardTraders({startDate, endDate}) {
        try {
            const { data } = await Vue.http.get(ENDPOINTS.TOP_GIFTCARD, {
                params: {
                    startDate,
                    endDate
                }
        });
            if (data.status == 200) {
                return data.data;
            }
            else {
                return []
            }

        } catch (error) {
            resolveRequestError(error);
        }


    }
    // ================= function payout reward ===================//

    static async payReward(giftcard) {

        try {
            const { data } = await Vue.http.post(ENDPOINTS.REWARD_PAY, giftcard);
            return data
        } catch (error) {
            resolveRequestError(error);
        }
    }

    //===================== functions for banner management ============//
    // create banner code
    static async createBanner(banner) {

        try {
            const { data } = await Vue.http.post(ENDPOINTS.CREATE_BANNER, banner);
            if (data.status == 200) {
                return data.data;
            }
            else {
                return []
            }

        } catch (error) {
            resolveRequestError(error);
        }


    }
    // get banner code
    static async getBanner() {

        try {
            const { data } = await Vue.http.get(ENDPOINTS.ALL_BANNER);
            if (data.message == "Image(s) fetched") {
                return data.data;
            }
            else {
                return []
            }

        } catch (error) {
            resolveRequestError(error);
        }


    }
    // delete banner code
    static async deleteBanner(id) {

        try {
            const { data } = await Vue.http.patch(ENDPOINTS.DELETE_BANNER, { ids: [id] });
            if (data.message == "Image(s) deleted") {
                return data.data;
            }
            else {
                return {}
            }

        } catch (error) {
            resolveRequestError(error);
        }


    }

    // toggle banner code
    static async toggleBanner(data2) {

        try {
            const { data } = await Vue.http.put(ENDPOINTS.TOOGLE_BANNER, data2);

            if (data.message == "Image(s) updated") {
                return data.data;
            }
            else {
                return {}
            }

        } catch (error) {
            resolveRequestError(error);
        }


    }

    // edit banner code
    static async editBanner(data2) {

        try {

            const { data } = await Vue.http.put(ENDPOINTS.EDIT_BANNER, data2);

            if (data.message == "Image(s) updated") {
                return data.data;
            }
            else {
                return {}
            }

        } catch (error) {
            resolveRequestError(error);
        }


    }

    //bonus endpoints
    static async getUsersDetails(data2) {

        try {

            const { data } = await Vue.http.post(ENDPOINTS.RETRIEVE_USER_DETAILS, data2);
            return data;

        } catch (error) {
            resolveRequestError(error);
        }


    }

    static async uploadBonus(data2) {

        try {

            const { data } = await Vue.http.post(ENDPOINTS.UPLOAD_BONUSES, data2);
            return data;

        } catch (error) {
            resolveRequestError(error);
        }


    }

    static async retrieveAllBonuses() {
        try {
            const { data } = await Vue.http.get(ENDPOINTS.GET_BONUS);
            return data;
        } catch (error) {
            resolveRequestError(error);
        }


    }
    static async getAllPromo() {
        try {
            const { data } = await Vue.http.get(ENDPOINTS.GET_PROMOS);
            console.log('the datas here', data);
            return data;
        } catch (error) {
            resolveRequestError(error);
        }


    }
    static async createPromoCode(code) {
        try {
            const { data } = await Vue.http.post(ENDPOINTS.GET_PROMOS, code);
            console.log('the datas here', data);
            return data;
        } catch (error) {
            resolveRequestError(error);
        }


    }
    static async editPromoCode({id, ...code}) {
        try {
            const { data } = await Vue.http.put(ENDPOINTS.GET_PROMOS + '?id='+ id, code);
            console.log('the datas here', data);
            return data;
        } catch (error) {
            resolveRequestError(error);
        }

    }
    static async createCouponCode(code) {
        try {
            const { data } = await Vue.http.post(ENDPOINTS.GET_COUPONS, code);
            console.log('the datas here', data);
            return data;
        } catch (error) {
            resolveRequestError(error);
        }


    }

    static async getAllCoupon() {
        try {
            const { data } = await Vue.http.get(ENDPOINTS.GET_COUPONS);
            console.log('the datas here', data);
            return data;
        } catch (error) {
            resolveRequestError(error);
        }


    }

    static async editCoupon(coupon) {
        try {
            console.log(coupon);
            const { data } = await Vue.http.put(ENDPOINTS.GET_COUPONS + '?id='+ coupon.id, coupon);
           
            return data;
        } catch (error) {
            resolveRequestError(error);
        }


    }

    static async getCouponUsers(couponId){
        try {
            const { data } = await Vue.http.get(ENDPOINTS.COUPON_USERS + '?id='+ couponId);  
            return data;
        } catch (error) {
            resolveRequestError(error);  
        }
    }
}